import React from 'react';

const path = process.env.PUBLIC_URL


const Graph = ( {image, title, source} ) => {
  return(
    <div className="graph__wrapper">
      <div className="graphtitle">{title}</div>
      <div className="small" dangerouslySetInnerHTML={{__html: source}} />
      <img src={path + '/images/' + image} alt="" />
    </div>
  )
}

export default Graph;